import { AdsProvider, RewardResult } from '../ads';
import { trackEvent } from '../events';

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

export class DemoAdsProvider implements AdsProvider {
  private ready = false;
  private bannerVisible = false;

  initialize(): Promise<void> {
    this.ready = true;
    return Promise.resolve();
  }

  showBanner(): Promise<void> {
    if (this.bannerVisible) {
      return Promise.resolve();
    }
    this.bannerVisible = true;
    trackEvent('ad_banner_shown', { provider: 'demo' });
    return Promise.resolve();
  }

  hideBanner(): Promise<void> {
    if (!this.bannerVisible) {
      return Promise.resolve();
    }
    this.bannerVisible = false;
    trackEvent('ad_banner_hidden', { provider: 'demo' });
    return Promise.resolve();
  }

  showInterstitial(): Promise<boolean> {
    trackEvent('ad_interstitial_shown', { provider: 'demo' });
    return delay(1200).then(() => true);
  }

  prepareRewarded(): Promise<boolean> {
    return Promise.resolve(this.ready);
  }

  isRewardedReady(): boolean {
    return this.ready;
  }

  showRewarded(): Promise<RewardResult> {
    if (!this.ready) {
      trackEvent('ad_rewarded_unavailable', { provider: 'demo' });
      return Promise.resolve('unavailable');
    }
    trackEvent('ad_rewarded_requested', { provider: 'demo' });
    return delay(1500).then(() => {
      trackEvent('ad_rewarded_granted', { provider: 'demo' });
      return 'granted' as RewardResult;
    });
  }
}
